import { createState, translations as sharedTranslations } from 'mage-i18n'
import { translations as configTranslations } from 'mage-config'
import { translations as componentTranslations } from 'mage-components'
import { translations as conversationTranslations } from 'mage-conversation'
import { ParticleDesignVersions } from 'mage-deps/@klarna/bubble-ui'

export default (window, createAppState, appTranslations, { sessionId } = {}) => ({
  config: window.config || {},
  core: {
    clientId: window.clientId,
    title: window.title,
    slug: window.slug,
    useBasename: window.useBasename,
    realm: 'merchants',
    showBetaLabel: window.showBetaLabel,
    designVersion: window.designVersion || ParticleDesignVersions.NEXT,
    sessionId
  },
  i18n: createState(
    configTranslations,
    componentTranslations,
    conversationTranslations,
    sharedTranslations,
    appTranslations
  ),
  ...createAppState(window)
})
